<template>
  <div class="page-mouthModal" v-if="visible">
    <div class="content">
      <div class="title">提示！</div>
      <div class="text" v-if="!status">
        <p>提交答案后，仍可查看病变放大图。</p>
        <p>但是不可再做修改。</p>
      </div>
      <div class="text" v-else>
        <p>请仔细审题</p>
        <p>选择正确数量的选项</p>
      </div>
      <div class="footer" v-if="!status">
        <button @click="handleCacenl">取消</button>
        <button @click="handleOk">确定</button>
      </div>
      <div class="footer" v-else>
        <button @click="handleOks">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pointModal",
  data() {
    return {
      visible: false, //弹窗状态
      status: false, //判断父级选择题是否超过两个
    };
  },
  computed: {},
  created() {},
  methods: {
    //多选未选够两个及以上 提示方法
    tip() {
      this.status = true;
      this.visible = true;
    },
    //显示弹窗方法
    handleShow() {
      this.status = false;
      this.visible = true;
    },
    //点击取消
    handleCacenl() {
      this.visible = false;
    },
    //点击确定
    handleOk() {
      this.$emit("ok", true);
      this.visible = false;
    },
    // 多选的确定
    handleOks() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.page-mouthModal {
  width: 100%;
  min-height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(#fff, 0.8);
  padding: 0 40px;
  display: flex;
  align-items: center;
  z-index: 1;
  .content {
    width: 100%;
    height: 642px;
    z-index: 999;
    background: #ffffff;
    background: rgba(255, 255, 255, 0.9);
    border: 2px solid #ffffff;
    border-radius: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 90px;
    padding-bottom: 77px;
  }
  .title {
    font-size: 65px;
    font-family: HarmonyOS Sans SC;
    font-weight: bold;
    color: #ab3b91;
  }
  .text {
    font-size: 35px;
    font-family: HarmonyOS Sans SC;
    font-weight: bold;
    color: #333333;
    line-height: 60px;
    margin-top: 80px;
    text-align: center;
  }
  .footer {
    margin-top: 110px;
    button {
      width: 262px;
      height: 79px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      text-align: center;
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 60px;
      letter-spacing: 2px;
      border-radius: 40px;
    }
    button:nth-child(2) {
      margin-left: 42px;
    }
  }
}
</style>
